import {EventEmitter, Output, Injectable} from '@angular/core';

@Injectable()
export class EmitterService {

    @Output() spinnerValue: EventEmitter<boolean> = new EventEmitter(true);
    @Output() loadHeader: EventEmitter<boolean> = new EventEmitter(true);
    @Output() USER_TZ: EventEmitter<any> = new EventEmitter();
    constructor() {}
    /**
     *@author nagendra 
     *@param spinParam(boolean)
     */
    setSpinner(spinParam) {
        this.spinnerValue.emit(spinParam);
    }

    /**
     *@author nagendra
     *@returns spinnerValue(boolean)
     */
    getSpinner() {
        return this.spinnerValue;
    }

    setloadHeader(islogin) {
        this.loadHeader.emit(islogin);
    }
    getloadHeader() {
        return this.loadHeader;
    }

    setTZ(tz) {
        this.USER_TZ.emit(tz);
    }
    getTZ() {
        return this.USER_TZ;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/services/emitter.service.ts